import axios from "@src/libraries/axios";
import Vue from "@src/libraries/vue";
import { moduleDebug } from "@src/assets/js/debug";
import { API_V2_URL } from "@src/assets/js/utils";
import usersStore from "@src/store/users";
import { router } from "@src/plugins/router";
const indexStore = new Vue({
    name: "ClientStore",
    data() {
        const data = {};
        return data;
    },
    computed: {
        alias() {
            const aliasParam = router.currentRoute.params.alias;
            if (aliasParam)
                return aliasParam;
            const saasClient = this.saasClient;
            if (!saasClient)
                return "";
            return saasClient.alias;
        },
        saasClient() {
            const saasClients = this.saasClients;
            return saasClients && saasClients[0];
        },
        domain() {
            const saasClient = this.saasClient;
            return saasClient && saasClient.domain || "";
        },
        key() {
            const saasClient = this.saasClient;
            return saasClient && saasClient.key || "";
        },
    },
    asyncComputed: {
        async saasClients() {
            const me = usersStore.me;
            if (!me)
                return;
            let response;
            try {
                response = await axios.get(API_V2_URL + `/saas-clients?failsafe=1`).catch(() => { });
            }
            catch (e) { }
            ;
            return response && response.data;
        }
    }
});
export default indexStore;
moduleDebug(indexStore);
